module.exports = __webpack_public_path__ + "static/media/praterairclassifyigmill.005eed09.png";